import { estruturaItensMap } from '../risrotEstruturaCatalog';
import RisrotEstruturaTable from './RisrotEstruturaTable';
import type { RisrotEstruturaBaseProps } from './RisrotEstruturaTable';

const ESTRUTURA = 'Área de justante ao pé da barragem' as const;

export default function EstruturaAreaJusante(props: RisrotEstruturaBaseProps) {
	return (
		<RisrotEstruturaTable
			{...props}
			structureName={ESTRUTURA}
			fixedItems={estruturaItensMap[ESTRUTURA]}
		/>
	);
}
